// Tekster for pipeline pakke 7 (mobil, kap. 16.10 og 17.6): Pipeline som
// liste gruppert per stadium, og handlingsarket nedenfra i detaljvisningen.
export const norwegianPipelineMobileMessages = {
  crm: {
    deals: {
      mobile: {
        list_label: "Muligheter per stadium",
        group_count:
          "%{stage}, %{smart_count} mulighet |||| %{stage}, %{smart_count} muligheter",
        no_stage: "Uten stadium",
        no_company: "Uten kunde",
        actions: "Handlinger",
        actions_label: "Handlinger for %{name}",
        next_step: "Neste steg",
        move_stage: "Flytt stadium",
        move_title: "Flytt til stadium",
        current_stage: "%{stage} (nå)",
        back: "Tilbake",
        call: "Ring",
        call_name: "Ring %{name}",
        no_phone: "Ingen telefonnummer på kontakten",
        email: "Åpne i e-post",
        no_email: "Ingen e-postadresse på kontakten",
        won: "Vunnet",
        lost: "Tapt",
        cancel: "Avbryt",
      },
    },
  },
};

export const englishPipelineMobileMessages = {
  crm: {
    deals: {
      mobile: {
        list_label: "Opportunities by stage",
        group_count:
          "%{stage}, %{smart_count} opportunity |||| %{stage}, %{smart_count} opportunities",
        no_stage: "No stage",
        no_company: "No customer",
        actions: "Actions",
        actions_label: "Actions for %{name}",
        next_step: "Next step",
        move_stage: "Move stage",
        move_title: "Move to stage",
        current_stage: "%{stage} (current)",
        back: "Back",
        call: "Call",
        call_name: "Call %{name}",
        no_phone: "The contact has no phone number",
        email: "Open in email",
        no_email: "The contact has no email address",
        won: "Won",
        lost: "Lost",
        cancel: "Cancel",
      },
    },
  },
};
